import {get, isNil, negate} from 'lodash/fp';
import isEmpty from 'lodash/isEmpty';
import {createSelector} from 'reselect';

import {ACCEPTDECLINE} from '/enum/candidates.enum';
import {fromProps} from '/util/selector.util';

import {candidate as candidateState} from './root.selector';

export const allCandidates = createSelector(
  candidateState,
  get('allCandidates'),
);

export const candidateById = createSelector(
  fromProps(get('candidateId')),
  allCandidates,
  (candidateId, candidates) => get(candidateId)(candidates),
);

export const hasProfileById = createSelector(candidateById, negate(isNil));

export const activatedOnById = createSelector(
  candidateById,
  get('activatedOn'),
);

export const phoneNumberById = createSelector(
  candidateById,
  get('phoneNumber'),
);

export const nameById = createSelector(candidateById, get('name'));

export const emailById = createSelector(candidateById, get('email'));

export const coachIdById = createSelector(candidateById, get('coachId'));

export const sourceById = createSelector(candidateById, get('source'));

export const urlDetailsById = createSelector(candidateById, get('urlDetails'));

export const notesById = createSelector(candidateById, get('notes'));

export const flagById = createSelector(candidateById, get('flag'));

export const acceptBeforeById = createSelector(
  candidateById,
  get('acceptBefore'),
);

export const referrerNameById = createSelector(
  candidateById,
  get('referrerName'),
);
export const expirationTimeById = createSelector(
  candidateById,
  get('expirationTime'),
);
export const statusById = createSelector(candidateById, get('status'));

export const candidateNameById = createSelector(candidateById, get('name'));

export const reminderDetailsById = createSelector(
  candidateById,
  get('reminderDetails'),
);

export const reminderStatusById = createSelector(
  reminderDetailsById,
  get('status'),
);

export const hasReminderDetails = createSelector(
  reminderDetailsById,
  negate(isEmpty),
);

export const isPendingAcceptance = createSelector(
  statusById,
  status => status === ACCEPTDECLINE,
);

export const clientDetailsById = createSelector(
  candidateById,
  get('clientDetails'),
);

export const notesUpdatedTsById = createSelector(
  candidateById,
  get('notesUpdatedTs'),
);

export const createdTsById = createSelector(candidateById, get('createdTs'));

export const allCandidateState = createSelector(
  candidateState,
  get('allCandidates'),
);
export const candidateStateValue = createSelector(
  fromProps(get('candidateId')),
  allCandidateState,
  (candidateId, candidates) => get('candidateId')(candidates),
);

export const declineReasons = createSelector(
  candidateState,
  get('declineReasons'),
);
export const dispositionOptions = createSelector(
  candidateState,
  get('dispositionDescription'),
);

export const hasdispositionOptions = createSelector(
  dispositionOptions,
  negate(isEmpty),
);

export const hasDeclineReasons = createSelector(
  declineReasons,
  negate(isEmpty),
);

export const dispositionDescription = createSelector(
  candidateById,
  get('dispositionDescription'),
);

export const dispositionTypeId = createSelector(
  candidateById,
  get('dispositionTypeId'),
);

export const getReferrals = createSelector(candidateState, get('referrals'));
